import { Stock } from "@/models/stock";
import useShortInterestPreload from "src/hooks/useShortInterestPreload";

/**
 * Preloads the stock's short-interest tab once the overview has started up (#1350). A component of
 * its own, rendering nothing, so that the user atom it reads re-renders only this, not the overview.
 */
const ShortInterestPreloader = ({ stock }: { stock: Stock }) => {
    useShortInterestPreload(stock);
    return null;
};

export default ShortInterestPreloader;
